// Create React App inlines REACT_APP_* at build time. These were hardcoded,
// which meant repointing the portal at a different API required a code change,
// a rebuild and a redeploy rather than an environment change.
//
// Set them in .env / .env.production, or in the CI environment, before `npm run build`.
const config = {
    apiUrl: process.env.REACT_APP_API_URL || 'https://repairs.cs.inc:7010',
    siteUrl: process.env.REACT_APP_SITE_URL || 'https://downloads.smallhd.com',
    downloadFirmwareUrl: process.env.REACT_APP_DOWNLOAD_FIRMWARE_URL
        || 'https://downloads.smallhd.com/dev/backend-node-server/firmware/',
    itemsimgUrl: process.env.REACT_APP_ITEMS_IMG_URL
        || 'https://cdn.shopify.com/s/files/1/0097/6004/7167/products/',
    productDetailUrl: process.env.REACT_APP_PRODUCT_DETAIL_URL || 'https://smallhd.com/products/',
    downloadFirmwarePrefix: process.env.REACT_APP_DOWNLOAD_FIRMWARE_PREFIX || 'smallhd_OS_'
};

export default config;
